import styled from '@emotion/styled';

export const CloseButton = styled.button`
  background: none;
  border: none;
  position: relative;
  height: 20px;
  width: 20px;

  &:hover {
    cursor: pointer;
  }

  &::before,
  &::after {
    content: '';
    height: 2px;
    background-color: #fff;
    width: 100%;
    position: absolute;
    left: 0;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;
